import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from '@/components/common/page-header';
import { JobList } from '@/components/indexing/job-list';
import { NewJobDialog } from '@/components/indexing/new-job-dialog';
import { RateTable } from '@/components/indexing/rate-table';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { urls } from '@/lib/urls';

/** Running the crawler: jobs, and the rate policies that pace them. */
export function IndexingPage() {
  const navigate = useNavigate();
  const params = useParams();
  const tab = params['tab'] === 'rates' ? 'rates' : 'jobs';
  const [starting, setStarting] = useState(false);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Indexing"
        actions={
          <Button onClick={() => setStarting(true)}>
            <Plus className="size-4" />
            Start a job
          </Button>
        }
      />
      <Tabs value={tab} onValueChange={(value) => navigate(urls.indexing(value === 'rates' ? 'rates' : 'jobs'))}>
        <TabsList>
          <TabsTrigger value="jobs">Jobs</TabsTrigger>
          <TabsTrigger value="rates">Rates</TabsTrigger>
        </TabsList>
        <TabsContent value="jobs" className="pt-4">
          <JobList />
        </TabsContent>
        <TabsContent value="rates" className="pt-4">
          <RateTable />
        </TabsContent>
      </Tabs>
      <NewJobDialog open={starting} onOpenChange={setStarting} />
    </div>
  );
}
